import React, { memo } from 'react';

import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { actionButtonStyles, containerStyles, titleStyles } from './AiActivityEmptyState.styles';
import { AiActivityEmptyStateTestIds } from './AiActivityEmptyState.testIds';

const AiActivityEmptyState = ({
  title,
  subtitle = null,
  actionLabel = null,
  dataTestId = null,
  onAction = null,
}) => {
  const showAction = !!actionLabel && !!onAction;

  return (
    <Box data-testid={dataTestId} sx={containerStyles}>
      <Typography sx={titleStyles} variant="medium14">
        {title}
      </Typography>
      {subtitle && <Typography variant="regular14">{subtitle}</Typography>}
      {showAction && (
        <Button
          data-testid={AiActivityEmptyStateTestIds.ACTION_BUTTON}
          sx={actionButtonStyles}
          variant="outlined"
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

AiActivityEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actionLabel: PropTypes.string,
  dataTestId: PropTypes.string,
  onAction: PropTypes.func,
};

export default memo(AiActivityEmptyState);
